<template>
  <a-modal
    :visible="visible"
    :width="500"
    :title="$t('fulfillment.export_modal.title')"
    class="modal-export-do"
    :dialog-style="{ top: '24px' }"
    :footer="false"
    :closable="false"
  >
    <a-form-model :model="form">
      <a-form-model-item prop="delivery_order_states" :label="$t('fulfillment.export_modal.do_status')">
        <a-select
          v-model="form.delivery_order_states"
          mode="multiple"
          :placeholder="$t('fulfillment.export_modal.select_do_status')"
          :options="doState"
          :disabled="isLoading"
          allow-clear
          @select="onSelectFilter($event, 'delivery_order_states', 'doState')"
        />
      </a-form-model-item>
      <a-form-model-item prop="booking_state" :label="$t('fulfillment.export_modal.inventory_status')">
        <a-select
          v-model="form.booking_state"
          mode="multiple"
          :placeholder="$t('fulfillment.export_modal.select_inventory_status')"
          :options="inventoryState"
          :disabled="isLoading"
          allow-clear
          @select="onSelectFilter($event, 'booking_state', 'inventoryState')"
        />
      </a-form-model-item>
      <a-form-model-item prop="warehouse_id" :label="$t('fulfillment.export_modal.warehouse')">
        <a-select
          v-model="form.warehouse_id"
          mode="multiple"
          :placeholder="$t('fulfillment.export_modal.select_warehouse')"
          :options="warehouseList"
          :disabled="isLoading"
          allow-clear
          @select="onSelectFilter($event, 'warehouse_id', 'warehouseList')"
        />
      </a-form-model-item>
      <a-form-model-item prop="channel_id" :label="$t('fulfillment.export_modal.channel')">
        <a-select
          v-model="form.channel_id"
          mode="multiple"
          :placeholder="$t('fulfillment.export_modal.select_channel')"
          :options="channelList"
          :disabled="isLoading"
          allow-clear
          @select="onSelectFilter($event, 'channel_id', 'channelList')"
        />
      </a-form-model-item>
      <a-form-model-item prop="service_type" :label="$t('fulfillment.export_modal.shipping_type')">
        <a-select
          v-model="form.service_type"
          mode="multiple"
          :placeholder="$t('fulfillment.export_modal.select_shipping_type')"
          :options="serviceList"
          :disabled="isLoading"
          allow-clear
          @select="onSelectFilter($event, 'service_type', 'serviceList')"
        />
      </a-form-model-item>
      <a-form-model-item prop="order_date" :label="$t('fulfillment.export_modal.order_date')">
        <a-range-picker
          v-model="form.order_date"
          :disabled-date="disabledDate"
          :show-time="{ format: 'HH:mm:ss' }"
          format="YYYY-MM-DD HH:mm:ss"
          :placeholder="[$t('fulfillment.export_modal.start_date'), $t('fulfillment.export_modal.end_date')]"
          style="display: contents"
          :disabled="isLoading"
          @calendarChange="calendarChange"
          @openChange="openChange"
        >
          <a-icon slot="suffixIcon" type="calendar" style="color: #0559cb" />
        </a-range-picker>
      </a-form-model-item>
      <a-form-model-item class="mb-0">
        <div class="text-right">
          <a-button class="mr-3" @click="closeModal">
            {{ $t('fulfillment.export_modal.close') }}
          </a-button>
          <a-button type="primary" :disabled="isLoading" :loading="isLoading" @click="submitModal">
            {{ $t('fulfillment.export_modal.export_data') }}
          </a-button>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>

export default {
  name: 'ModalExportData',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    doState: {
      type: Array,
      default: () => [],
    },
    warehouses: {
      type: Array,
      default: () => [],
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        delivery_order_states: ['all'],
        booking_state: ['all'],
        warehouse_id: ['all'],
        channel_id: ['all'],
        service_type: ['all'],
        order_date: [this.$moment().subtract(30, 'days').startOf('day').format(), this.$moment().endOf('day').format()],
        start_date: this.$moment().subtract(30, 'days').startOf('day').format(),
        end_date: this.$moment().endOf('day').format(),
      },
    }
  },
  computed: {
    inventoryState() {
      return [
        { value: 'all', label: this.$t('fulfillment.export_modal.all') },
        { value: 'SUCCESS_ALLOCATED', label: this.$t('fulfillment.export_modal.booked') },
        { value: 'NOT_YET_ALLOCATED', label: this.$t('fulfillment.export_modal.pending') },
        { value: 'ALLOCATION_FAILED', label: this.$t('fulfillment.export_modal.oos') },
      ]
    },
    isLoading() {
      return this.loading
    },
    warehouseList() {
      if (this.warehouses?.length) {
        let listWhs = []
        this.warehouses.forEach(item => {
          listWhs.push({
            value: item?.id || item?.warehouse_id,
            label: item.name,
          })
        })
        listWhs.unshift({
          label: this.$t('fulfillment.export_modal.all'),
          value: 'all',
        })
        return listWhs
      }
      return []
    },
    channelList() {
      let listCh = this.$store.state.business.listChannels.map(channel => ({
        value: channel.id.toString(),
        label: channel.title,
      }))
      listCh.unshift({
        label: this.$t('fulfillment.export_modal.all'),
        value: 'all',
      })
      return listCh
    },
    serviceList() {
      if (this.services?.length) {
        let listSvc = JSON.parse(JSON.stringify(this.services))
        listSvc.unshift({
          label: this.$t('fulfillment.export_modal.all'),
          value: 'all',
        })
        return listSvc
      }
      return []
    },
  },
  methods: {
    onSelectFilter(value, type, list) {
      if (value === 'all') {
        this.form[type] = ['all']
      } else {
        if (this.form[type].includes('all')) {
          this.form[type] = this.form[type].filter(val => val !== 'all')
        } else {
          if (this.form[type].length === (this[list].length - 1)) {
            this.form[type] = ['all']
          }
        }
      }
    },
    openChange(open) {
      if (open) {
        this.form.start_date = null
      }
    },
    calendarChange(value) {
      this.form.start_date = value[0]
      this.form.end_date = value[1]
    },
    disabledDate(current) {
      const tooLate = current && current > this.$moment().endOf('day');
      return tooLate
    },
    closeModal() {
      this.form = {
        delivery_order_states: ['all'],
        booking_state: ['all'],
        warehouse_id: ['all'],
        channel_id: ['all'],
        service_type: ['all'],
        order_date: [this.$moment().subtract(30, 'days').startOf('day').format(), this.$moment().endOf('day').format()],
        start_date: this.$moment().subtract(30, 'days').startOf('day').format(),
        end_date: this.$moment().endOf('day').format(),
      }
      this.$emit('handleShowModal', false)
    },
    submitModal() {
      this.$emit('handleSubmitModal', this.form)
    },
  },
}
</script>

<style lang="scss">
.modal-export-do {
  .ant-modal-body {
    padding: 12px 24px;

    .ant-form-item {
      margin-bottom: 12px;
    }

    .ant-form-item-label {
      line-height: normal;

      label {
        line-height: normal;
      }
    }
  }
}
</style>